import React from "react";
import { Code2, Cloud, Network, Lightbulb, ArrowUpRight } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const ICONS = [Code2, Cloud, Network, Lightbulb];

export const Services = () => {
  const { t } = useLanguage();

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-t border-slate-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14 md:mb-20">
          <p
            className="text-[11px] tracking-[0.2em] uppercase text-blue-400 mb-5"
            style={{ fontFamily: "'IBM Plex Mono', monospace" }}
          >
            {t.services.overline}
          </p>
          <h2
            className="text-3xl md:text-5xl font-bold tracking-tight text-slate-50 leading-tight"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            data-testid="services-title"
          >
            {t.services.title}
          </h2>
          <p
            className="mt-5 text-base md:text-lg text-slate-400 max-w-2xl"
            style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
          >
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 border border-slate-800">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i];
            const isRight = i % 2 === 1;
            const isBottom = i >= 2;
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className={`group relative p-8 md:p-10 lg:p-12 bg-slate-900/30 hover:bg-slate-900/60 transition-colors duration-300
                  ${isRight ? "md:border-l border-slate-800" : ""}
                  ${isBottom ? "border-t md:border-t border-slate-800" : ""}
                `}
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="flex-1">
                    <div
                      className="inline-flex items-center justify-center w-12 h-12 border border-slate-800 bg-slate-950 text-blue-400 mb-7 group-hover:border-blue-500/50 group-hover:text-blue-300 transition-colors"
                      aria-hidden="true"
                    >
                      <Icon size={20} />
                    </div>
                    <h3
                      className="text-xl md:text-2xl font-semibold text-slate-50 tracking-tight"
                      style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                    >
                      {item.title}
                    </h3>
                    <p
                      className="mt-3 text-sm md:text-base text-slate-400 leading-relaxed max-w-md"
                      style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
                    >
                      {item.desc}
                    </p>
                  </div>
                  <ArrowUpRight
                    size={20}
                    className="text-slate-600 group-hover:text-blue-400 transition-colors duration-300 shrink-0 mt-1"
                  />
                </div>
                <span
                  className="absolute top-6 right-6 text-[10px] tracking-[0.2em] uppercase text-slate-600"
                  style={{ fontFamily: "'IBM Plex Mono', monospace" }}
                >
                  0{i + 1}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
